export function FilledSocialReferralSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/filled-social-referal.svg'"></ng-include>`
    }
}